// extracted by mini-css-extract-plugin
module.exports = {"Card":"style_Card__38ve_","Btn":"style_Btn__RDX5X","Marck":"style_Marck__3VP9y","Wrapper":"style_Wrapper__3G-t-","Content":"style_Content__2g77B","Avatar":"style_Avatar__CBwAg"};